import { render, staticRenderFns } from "./ProductsTableProduct.vue?vue&type=template&id=3b1e68fa"
import script from "./ProductsTableProduct.vue?vue&type=script&lang=js"
export * from "./ProductsTableProduct.vue?vue&type=script&lang=js"
import style0 from "./ProductsTableProduct.vue?vue&type=style&index=0&id=3b1e68fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports